import { NOT_NUMBER_REGEXP, PHONE_INPUT_DEFAULT_MASK } from '../constants';

class PhoneInputFormatService {
  static getDisplayPhoneNumber(value, mask = PHONE_INPUT_DEFAULT_MASK) {
    if (!value) {
      return value;
    }

    let displayValue = '';
    let lastValueCharIndex = 0;

    for (let i = 0; i < mask.length; i++) {
      const maskChar = mask[i];
      const valueChar = value[lastValueCharIndex];
      const isNumber = !maskChar.match(NOT_NUMBER_REGEXP);

      if (!valueChar) {
        break;
      } else if (isNumber) {
        displayValue += valueChar;
        lastValueCharIndex += 1;
      } else {
        displayValue += maskChar;
      }
    }

    return displayValue;
  }
}

export default PhoneInputFormatService;
